import device from '../helpers/device'

class ImageSwiper {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    if (!this.ui.$image.getAttribute('style')) {
      this.bindEvents()
    }
  }

  bindUI() {
    this.ui = {}
    this.ui.$image = this.el.querySelector('.js-image-swiper-overlay')
    this.ui.$imageDefault = this.el.querySelector('.js-image-swiper-default')
    this.ui.$desc = this.el.querySelector('.js-image-swiper-desc')
    if (!this.ui.$image.getAttribute('style')) {
      this.ui.$image.querySelector('img').width = this.ui.$image.offsetWidth
      this.ui.$image.querySelector('img').height = this.ui.$image.offsetHeight
      this.ui.$image.parentNode.style.height = `${this.ui.$imageDefault.querySelector('img').offsetHeight}px`
      this.w = (device.width - 40)
      this.h = this.ui.$imageDefault.querySelector('img').offsetHeight
      this.slider = null
      this.img = null
      this.clicked = 0
      this.pos = 0
    }
  }

  bindEvents() {
    this.compareImages(this.ui.$image)
    this.el.addEventListener("click", this.onClick.bind(this));
  }

  compareImages(img) {
    this.img = img
    this.img.style.height =( this.h / 2) + 'px';

    this.slider = document.createElement("DIV");
    this.slider.setAttribute("class", "img-comp-slider");
    this.img.parentElement.insertBefore(this.slider, this.img);

    this.slider.addEventListener("mousedown", this.onSlideReady.bind(this));
    window.addEventListener("mouseup", this.onSlideFinish.bind(this));
    this.slider.addEventListener("touchstart", this.onSlideReady.bind(this));
    window.addEventListener('touchend', this.onSlideFinish.bind(this))
  }

  onClick(e) {
    let target = e.currentTarget
    if(!target.matches('.js-image-swiper')) return

    let desc = target.querySelector('.js-image-swiper-desc')
    if(desc != void 0)
      desc.remove()
  }

  onSlideReady(e) {
    e.preventDefault();
    this.clicked = 1;
    if (this.ui.$desc != void 0)
      this.ui.$desc.remove()
    window.addEventListener("mousemove", this.onSlideMove.bind(this));
    window.addEventListener("touchmove", this.onSlideMove.bind(this));
    if (window.sliderdefault) {
      window.sliderdefault.params.draggable = false
      window.sliderdefault.update()
    }
    if (window.sliderstorie) {
      window.sliderstorie.params.draggable = false
      window.sliderstorie.update()
    }
  }

  onSlideFinish() {
    this.clicked = 0;
    if (window.sliderdefault) {
      window.sliderdefault.params.draggable = true
      window.sliderdefault.update()
    }
    if (window.sliderstorie) {
      window.sliderstorie.params.draggable = true
      window.sliderstorie.update()
    }
  }

  onSlideMove(e) {
    if (this.clicked == 0) return false;

    this.pos = this.getCursorPos(e)
    if (this.pos < 0) this.pos = 0;
    if (this.pos > this.h) this.pos = this.h;
    this.slide(this.pos);
  }

  getCursorPos(e) {
    let a, x, y = 0;
    e = (e.changedTouches) ? e.changedTouches[0] : e;
    a = this.img.getBoundingClientRect();
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return y;
  }

  slide(y) {
    this.img.style.height = `${y}px`;
    this.slider.style.top = y + 'px';
  }
}

export default ImageSwiper
